<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconWaiting_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M3.227 4.364h6.046q-.06.293-.061.606a3.03 3.03 0 0 0 4.243 2.778v3.813c0 1.044-.85 1.893-1.895 1.893H3.227a1.896 1.896 0 0 1-1.894-1.893V6.258c0-1.045.85-1.894 1.894-1.894m3.963 4.84c1.001 0 1.815-.814 1.815-1.814S8.19 5.576 7.19 5.576s-1.814.813-1.814 1.814c0 1 .814 1.814 1.814 1.814m2.972 1.658c-.474-.506-1.366-.882-2.972-.882-1.62 0-2.513.383-2.983.895l-.012.013c-.127.139-.333.362-.419.913a.495.495 0 0 0 .49.568h5.85c.3 0 .535-.27.488-.568-.087-.558-.297-.784-.434-.93z"
        clip-rule="evenodd"
    />
    <path
        fill="currentColor"
        d="M12.242 2.545a2.424 2.424 0 1 0 0 4.849 2.424 2.424 0 0 0 0-4.849m1.288 3.132a.26.26 0 0 1-.352.102l-1.06-.582a.26.26 0 0 1-.135-.227V3.238a.26.26 0 0 1 .52 0v1.578l.925.508a.26.26 0 0 1 .102.353"
    />
</svg>
